import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { fadeIn } from 'ng-animate';
import * as authActions from '@mnz-modules/login/store/actions/auth.actions';
import { IRootState } from '@mnz-core/modules/store/models/root-state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'mnz-choose-account',
  templateUrl: 'choose-account.page.html',
  animations: [trigger('fadeIn', [transition('* => *', useAnimation(fadeIn, { params: { timing: 0.5 } }))])],
})
export class ChooseAccountPage implements OnInit {
  constructor(
    @Inject(APP_CONFIG) private readonly _config: IAppConfiguration,
    private readonly _router: Router,
    private readonly _store$: Store<IRootState>
  ) {}

  requestAccount(): void {
    this._router.navigate(['/account-activeren']);
  }

  goToMoreInfo(): void {
    const { ns_business_url } = this._config.footerUrls;
    location.assign(ns_business_url);
  }

  ngOnInit(): void {
    // ensure user is logged out
    this._store$.dispatch(authActions.logout());
  }
}
